export const SETTINGS_NAVIGATION_GROUPS = {
	general: {
		title: '$t:pages.settings.sections.general.title',
		sort: 1,
	},
	access: {
		title: '$t:pages.settings.sections.access.title',
		sort: 2,
	},
};

export type SettingsNavigationGroupId = keyof typeof SETTINGS_NAVIGATION_GROUPS;
